export default __webpack_public_path__ + "img/primary_2.png";